module.exports = {
    clientURL: 'https://book-man.netlify.app',
    serverURL: 'https://bookman-server.herokuapp.com' 
};